import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseApiService } from '../../shared/base-service/base-api.service';
import { NotificationCreationModel } from '../models/notification-creation.model';
import { NotificationEmailModel } from '../models/notification-email.model';

@Injectable()
export class NotificationService extends BaseApiService {
    getNotificationChannels() {
        return this.get('Foundation/Notification/NotificationChannels/');
    }

    getAvailableTeams() {
        return this.get('Foundation/Notification/AvailableTeams/');
    }

    getUsersForBusinessUnit() {
        return this.get('Foundation/Notification/BusinessUnitUsers/');
    }

    saveNotification(model: NotificationCreationModel) {
        return this.post('Foundation/Notification', model);
    }

    getMessages() {
        return this.get('Foundation/Notification/Messages/');
    }

    getAlerts() {
        return this.get('Foundation/Notification/Alerts/');
    }

    getMessageCount() {
        return this.get('Foundation/Notification/Messages/Count')
            .pipe(map(response => response.result));
    }

    deleteMessage(messageDispositionId: number) {
        return this.delete('Foundation/Notification/Messages/Delete/' + messageDispositionId);
    }

    deleteAllMessages() {
        return this.delete('Foundation/Notification/Messages/DeleteAll');
    }

    getBestAvailableEmail(customerNumberId: number) {
        return this.get('Customer/Record/Contacts/BestAvailable/Email/' + customerNumberId);
    }

    getBestAvailableSms(customerNumberId: number) {
        return this.get('Customer/Record/Contacts/BestAvailable/Sms/' + customerNumberId);
    }

    markMessageRead(notificationMesaageDispositionId: number, isRead: boolean = true) {
        return this.post('Foundation/Notification/Messages/' + notificationMesaageDispositionId + '/IsRead/' + isRead, null);
    }

    getEmailMessage(notificationmessageId: number): Observable<NotificationEmailModel> {
        return this.get('Foundation/Notification/NotificationEmail/' + notificationmessageId);
    }
}
